angular.module('impactx.list').service('ListSelection', [
    'dataGen',
    ListSelection]);

/**
 * ListSelection returns a promise which eventually resolves to a list of ids for a given list config.
 *
 * @param dataGen dataGen to access backend
 * @returns {{getAllListIds: (function(*=, *): *)}}
 */
function ListSelection(dataGen) {
    function getAllListIds(listConfig, endpoint) {
        var uri = endpoint ? endpoint : '/list/ids';

        return dataGen.getData({}, {config: listConfig}, uri).then(function (result) {
            return impactX.isDefined(result, 'data.entries');
        });
    }

    return {
        getAllListIds: getAllListIds
    };
}